import IllustrationGetIfFromAppleStore from '@picsart/illustrations/IllustrationGetIfFromAppleStore';
import IllustrationGetItFromGooglePlay from '@picsart/illustrations/IllustrationGetItFromGooglePlay';
import IllustrationGetItFromMicrosoft from '@picsart/illustrations/IllustrationGetItFromMicrosoft';

// @ts-ignore
var socialIcons = [{
  component: IllustrationGetIfFromAppleStore,
  url: 'https://apps.apple.com/us/app/picsart-photo-studio/id587366035',
  extensionClassName: 'apple',
  label: 'apple store',
  storeName: 'app_store',
  dataTest: 'apple-logo',
  ariaLabel: 'IOS App Icon'
}, {
  component: IllustrationGetItFromGooglePlay,
  url: 'https://play.google.com/store/apps/details?id=com.picsart.studio',
  extensionClassName: 'google',
  label: 'android store',
  storeName: 'google_play',
  dataTest: 'android-logo',
  ariaLabel: 'Android App Icon'
}, {
  component: IllustrationGetItFromMicrosoft,
  url: 'https://apps.microsoft.com/store/detail/9WZDNCRFJ10M?launch=true&mode=mini',
  extensionClassName: 'microsoft',
  label: 'windows store',
  storeName: 'microsoft_store',
  dataTest: 'windows-logo',
  ariaLabel: 'Windows App Icon'
}];

export { socialIcons as s };
//# sourceMappingURL=socialIcons-13793a15.js.map
